import * as React from 'react';

import Primitive from '../primitives';

export type ModalProps = React.ComponentPropsWithoutRef<typeof Primitive.Dialog.Root>;

const Modal = (props: ModalProps) => <Primitive.Dialog.Root {...props} />;

Modal.displayName = 'Modal';

export default Modal;
